import React from 'react';
import { useParams } from 'react-router';
import Loader from '@/components/common/Loader';
import translate from '@/lib/intl/translate';
import {
  ConstituentIWaveConnectForm,
  ConstituentIWaveDetailedSummary,
  ConstituentIWaveScoreBreakdown,
  useConstituentIWaveData,
} from '@/modules/IWaveIntegration';

export default function ConstituentIWaveTab() {
  const { constituentId } = useParams<{ constituentId: string }>();
  const { isLoading, iwaveProfile, onRefreshData } =
    useConstituentIWaveData(constituentId);

  if (isLoading) {
    return <Loader isCentered className="my-4" />;
  }

  return (
    <div data-theme="v2">
      <h2 className="type-h1">{translate('IWAVE')}</h2>

      <div className="grid grid-cols-1 gap-6">
        <ConstituentIWaveConnectForm
          connected={!!iwaveProfile}
          constituentId={constituentId}
          iWaveId={iwaveProfile?.extProfileId}
          lastUpdated={iwaveProfile?.updated}
          onRefresh={onRefreshData}
        />

        {!!iwaveProfile && (
          <>
            <ConstituentIWaveScoreBreakdown iwaveProfile={iwaveProfile} />

            <ConstituentIWaveDetailedSummary iwaveProfile={iwaveProfile} />
          </>
        )}
      </div>
    </div>
  );
}
